import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ReactSession } from 'react-client-session';
import InputEmoji from "react-input-emoji";
import { Markup } from 'interweave';
import MicRecorder from 'mic-recorder-to-mp3';
import { Player } from 'react-simple-player';
import {Helmet} from "react-helmet";

import Badge from 'react-bootstrap/Badge';
import Loader from "../../Global/Loader";

import '../Dashboard.css';
import './Messages.css';
import classes from "./Messages.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

import noThumb from "../../../images/no-thumb.jpg";

const recorder = new MicRecorder({bitRate: 128});

function secToTime(sec) {
    var date = new Date(0);
    date.setSeconds(sec); // specify value for SECONDS here
    var timeString = date.toISOString().substring(11, 19);
    return timeString;
}

function Messages() {
    const { c_id, uid } = useParams();
    const navigate = useNavigate();
    const [partners, setPartners] = useState([]);
    const [conv, setConv] = useState(null);
    const [partner, setPartner] = useState([]);
    const [messages, setMessages] = useState([]);
    const [text, setText] = useState("");
    const [file, setFile] = useState([]);
    const [activeFile, setActiveFile] = useState(false);
    const [loading, setLoading] = useState(false);
    const [intervalId, setIntervalId] = useState(0);

    const [isRecording, setIsRecording] = useState(false);
    const [activeRecorder, setActiveRecorder] = useState(false);
    const [recordedFile, setRecordedFile] = useState([]);
    const [counter, setCounter] = useState(0);
    const [counterId, setCounterId] = useState(0);
    const [isSending, setIsSending] = useState(false);

    ReactSession.setStoreType("localStorage");
    const logged_user = ReactSession.get("logged_user");

    useEffect(() => {
        if(uid !== undefined) {
            axios.post(`${process.env.REACT_APP_API_URL}/api/user/conversation.php`, {
                user_id: logged_user,
                uid: uid,
                action: 'GET_CONV',
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(res => {
                setConv(parseInt(res.data));
            }).catch(err => {
                console.log(err);
            })
        }else {
            setConv(c_id);
        }
    }, [logged_user, uid, c_id]);

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/conversation.php`, 
            {
                user_id: logged_user,
                action: 'GET_PARTNERS'
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                // console.log(res.data);
                setPartners(res.data);
            }).catch(err => {
                console.log(err);
            })
    }, [logged_user]);

    const scrollToBottom = () => {
        var element  = document.getElementById("chat_area");
        element.scrollTop = element.scrollHeight;
    }

    const loadMessage = () => {
        if (intervalId) {
            clearInterval(intervalId);
        }

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/conversation.php`,
            {
                user_id: logged_user,
                c_id: conv,
                action: 'GET_MESSAGES',
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(res => {
                // console.log(res.data);
                setPartner(res.data.partner || []);
                setMessages(res.data.messages || []);
                scrollToBottom();

                ReactSession.set("conv", conv);
                const newIntervalId = setInterval(() => {
                    updateMessages();
                }, 3000);
                setIntervalId(newIntervalId);
                setLoading(true);
            }).catch(err => {
                console.log(err);
            })
    }

    const updateMessages = () => {
        let uid = ReactSession.get("conv");

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/conversation.php`,
            {
                user_id: logged_user,
                c_id: uid,
                action: 'GET_MESSAGES',
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(res => {
                // console.log(res.data);
                setPartner(res.data.partner || []);
                setMessages(res.data.messages || []);
            }).catch(err => {
                console.log(err);
            })
    }
    
    useEffect(() => {
        loadMessage();
        setFile([]);
        setActiveFile(false);
    } , [conv]);

    const sendMessage = () => {
        setIsSending(true);
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/conversation.php`, {
            user_id: logged_user,
            c_id: conv,
            msg_body: text,
            file: file,
            action: 'ADD_MESSAGE',
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            // console.log(res.data);
            loadMessage();
            setIsSending(false);
        }).catch(err => {
            console.log(err);
        })
    }

    function handleOnEnter() {
        !isSending && sendMessage();
    }

    const onImageChange = (e) => {
        setFile(e.target.files[0]);
        setActiveFile(true);

        if(!e.target.files[0]){
            setActiveFile(false);
        }
    }

    const startRecording = () => {
        setIsRecording(true);
        setActiveRecorder(true);
        const id = setInterval(() => setCounter((oldCount) => oldCount + 1), 1000);

        setCounterId(id);

        recorder.start().then(() => {
            // button.textContent = 'Stop recording';
            // button.classList.toggle('btn-danger');
            // button.removeEventListener('click', startRecording);
            // button.addEventListener('click', stopRecording);
            console.log("recording...");
          }).catch((e) => {
            console.error(e);
          });
    }

    const stopCounter = () => {
        if (counterId) {
            clearInterval(counterId);
        }

        setCounter(0);
    }

    const stopRecording = () => {
        setActiveRecorder(false);
        stopCounter();

        recorder.stop().getMp3().then(([buffer, blob]) => {
            // console.log(buffer, blob);
            const file = new File(buffer, 'music.mp3', {
                type: blob.type,
                lastModified: Date.now()
            });

            setFile(file);
            // console.log(file);

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                setRecordedFile(reader.result);
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }).catch((e) => {
            // console.error(e);
            console.log("err");
        });
    }

    const deleteRecording = () => {
        setIsRecording(false);
        setRecordedFile([]);
        setFile(false);
        stopCounter();
    }

    useEffect(() => {
        // console.log(recordedFile);
        // console.log(recordedFile.length !== 0 ? 'hi' : 'hello');
    }, [recordedFile])

    const sendVoiceNote = () => {
        setIsSending(true);
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/conversation.php`, {
            user_id: logged_user,
            c_id: conv,
            msg_body: '',
            file: file,
            action: 'ADD_MESSAGE',
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            // console.log(res.data);
            loadMessage();
            deleteRecording();
            setIsSending(false);
        }).catch(err => {
            console.log(err);
        })
    }

    return (
        <>
            <Helmet>
                <title>Messages</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <Sidebar active="messages" />
                    <div className={styles.main_content}>
                        <div className={`${styles.content_body} ${classes.content_body}`}>
                            <div className={`${classes.app}`}>
                                <div className={`${styles.title} pb-3`}>
                                    <h5><i className="fa-regular fa-comments"></i> Messages</h5>
                                </div>
                                {/* <button onClick={() => startRecording()}>Start</button>
                                <button onClick={() => stopRecording()}>Stop</button> */}
                                <div className={classes.content_wrapper}>
                                    <div className={classes.conversation_area}>
                                        {
                                            partners && partners.map && partners.map((partner, index) => {
                                                return (
                                                    <div className={`${classes.msg} ${partner.is_active ? classes.online : ''} ${classes.active}`} key={index}>
                                                        <Link to={`/dashboard/messages/${partner.c_id}`}>
                                                            <img className={classes.msg_profile} src={partner.avatar} onError={e => {e.target.src = noThumb}} alt={partner.name} />
                                                            <div className={classes.msg_details}>
                                                                <div className={classes.msg_username}><Markup content={partner.name}></Markup> {partner.unread > 0 ? <Badge pill bg="danger">{partner.unread}</Badge> : ''}</div>
                                                                <div className={classes.msg_content}>
                                                                    <span className={classes.msg_date}>{partner.at_time}</span>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className={classes.chat_area} id="chat_area">
                                        {
                                            loading && conv ? <>
                                                <div className={classes.chat_area_header}>
                                                    {/* <div className={classes.chat_area_title}><Markup content={partner.name || 'Deleted user'}></Markup></div> */}
                                                    <div className={classes.chat_area_title}>
                                                        {
                                                            partner.name ? <Link to={`/profile/${partner.id}/${partner.username}`}><Markup content={partner.name}></Markup></Link>
                                                            : 'Deleted user'
                                                        }
                                                    </div>
                                                    </div>
                                                    <div className={classes.chat_area_main}>
                                                        {
                                                            messages && messages.map && messages.length > 0 ? messages.map((message, index) => {
                                                                return (
                                                                    <div data-id={message.msg_id} className={`${classes.chat_msg} ${message.by_user === logged_user && classes.owner}`} key={index}>
                                                                        <div className={classes.chat_msg_profile}>
                                                                            <Link to={`/profile/${message.by_user}/${message.nice_url}`}>
                                                                                <img className={classes.chat_msg_img} src={message.avatar} onError={e => {e.target.src = noThumb}} alt={message.name} />
                                                                            </Link>
                                                                            <div className={classes.chat_msg_date}>{message.at_time}</div>
                                                                        </div>
                                                                        <div className={classes.chat_msg_content}>
                                                                            <div className={classes.chat_msg_text}><Markup content={message.reply} /></div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                            : <div className={classes.start_conv_msg}>
                                                                    <h3 className="text-muted">Say hi to <span>{partner.name || 'Deleted user'}</span></h3>
                                                                    <div className="cute-line"></div>
                                                                </div>
                                                        }
                                                    </div>
                                                    <div className={classes.chat_area_footer}>
                                                        {
                                                            !isRecording ? <div className={classes.footer_main}>
                                                                {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-video">
                                                                    <path d="M23 7l-7 5 7 5V7z" />
                                                                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                                                                </svg>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-image">
                                                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                                                    <circle cx="8.5" cy="8.5" r="1.5" />
                                                                    <path d="M21 15l-5-5L5 21" />
                                                                </svg>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <path d="M12 8v8M8 12h8" />
                                                                </svg> */}
                                                                <div className={`${classes.file} ${activeFile ? classes.activeFile : ''}`}>
                                                                    <label htmlFor='input-file'>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M26.052 15.998c-.086 0-.17 0-.252.002.132-.658.2-1.33.2-2 0-5.514-4.486-10-10-10-5.51 0-10 4.442-10.006 9.898l.016.202C2.584 14.59 0 17.556 0 21c0 3.492 2.516 6.496 6 7h5a1 1 0 0 0 0-2l-4.854.01C3.822 25.668 2 23.466 2 21c0-2.456 1.844-4.57 4.292-4.92l.86-.124a1 1 0 0 0 .858-.99l-.016-1.064C8 9.544 11.59 6 16 6c4.412 0 8 3.588 8 8 0 .542-.054 1.088-.164 1.618l-.264 1.272c-.066.318.028.646.248.884.22.236.536.358.864.308.022-.002.648-.084 1.368-.084C28.23 17.998 30 19.792 30 22c0 2.206-1.794 4-4 4h-7c-2.8 0-2.99-1.678-3-2v-6.636l2.366 2.364a1 1 0 0 0 1.414-1.414l-4.024-4.022a1.002 1.002 0 0 0-.712-.292c-.016 0-.028-.008-.044-.008a.987.987 0 0 0-.724.318l-4.028 4.024a1 1 0 0 0 1.414 1.414L14 17.412V24c0 1.382 1.044 4 5 4h7c3.308 0 6-2.692 6-6s-2.668-6.002-5.948-6.002z"/></svg>
                                                                    </label>
                                                                    <input type="file" name="img" id="input-file" onChange={onImageChange} />
                                                                </div>
                                                                {/* <input type="text" placeholder="Type something here..." /> */}
                                                                <div className={classes.reactEmoji}>
                                                                    <InputEmoji
                                                                        value={text}
                                                                        onChange={setText}
                                                                        cleanOnEnter
                                                                        onEnter={handleOnEnter}
                                                                        placeholder="Type a message"
                                                                    />
                                                                </div>
                                                                {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-smile">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" />
                                                                </svg>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-thumbs-up">
                                                                    <path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3" />
                                                                </svg> */}
                                                                <div className={classes.voiceRecorder} onClick={() => startRecording()}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g data-name="Layer 2"><g data-name="mic"><path d="M12 15a4 4 0 0 0 4-4V6a4 4 0 0 0-8 0v5a4 4 0 0 0 4 4z"/><path d="M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V20H8.89a.89.89 0 0 0-.89.89v.22a.89.89 0 0 0 .89.89h6.22a.89.89 0 0 0 .89-.89v-.22a.89.89 0 0 0-.89-.89H13v-2.08A7 7 0 0 0 19 11z"/></g></g></svg>
                                                                </div>
                                                                <button id="sendChatt" className="btn btn-primary message_input_btn" type="button" onClick={() => sendMessage()} disabled={isSending}>{isSending ? 'SENDING...' : 'SEND'}</button>
                                                            </div>
                                                            : <div className={classes.voiceNote}>
                                                            <div className={classes.left}>
                                                                <div className={classes.delete} onClick={() => deleteRecording()}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M2.556 7.338a1.5 1.5 0 0 0 1.5 1.5h.8v17.725A4.942 4.942 0 0 0 9.792 31.5h12.416a4.942 4.942 0 0 0 4.936-4.937V8.838h.8a1.5 1.5 0 0 0 0-3h-5.25V4.29c0-2.09-1.7-3.791-3.79-3.791h-5.808c-2.09 0-3.79 1.7-3.79 3.791v1.547h-5.25a1.5 1.5 0 0 0-1.5 1.5zm9.75-3.047c0-.437.354-.791.79-.791h5.808c.436 0 .79.354.79.791v1.547h-7.389V4.29zm-4.45 4.547h16.288v17.725a1.939 1.939 0 0 1-1.936 1.937H9.792a1.939 1.939 0 0 1-1.936-1.937V8.838z"/><path d="M12.272 25.737a1.5 1.5 0 0 0 1.5-1.5V13.101a1.5 1.5 0 0 0-3 0v11.136a1.5 1.5 0 0 0 1.5 1.5zm7.456 0a1.5 1.5 0 0 0 1.5-1.5V13.101a1.5 1.5 0 0 0-3 0v11.136a1.5 1.5 0 0 0 1.5 1.5z"/></svg>
                                                                </div>
                                                            </div>
                                                            <div className={classes.right}>
                                                                {/* <div className={classes.count}>00:05</div> */}
                                                                {/* <AudioPlayer
                                                                    autoPlay
                                                                    loop = {false}
                                                                    src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
                                                                    onPlay={e => console.log("onPlay")}
                                                                    // other props here
                                                                /> */}
                                                                {
                                                                    !activeRecorder ? <div className={classes.player}><Player src={recordedFile} height={40} /></div> : <div className={classes.timer}>{secToTime(counter)}</div>
                                                                }
                                                                {
                                                                    activeRecorder ?  <div className={`${classes.stop} ${classes.active}`} onClick={() => stopRecording()} title="Stop">
                                                                        <svg xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h48v48H0z"/><path d="M12 12h24v24H12z"/></svg>
                                                                    </div>
                                                                    : <div className={`${classes.voiceRecorder} ${classes.active}`} onClick={() => startRecording()}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g data-name="Layer 2"><g data-name="mic"><path d="M12 15a4 4 0 0 0 4-4V6a4 4 0 0 0-8 0v5a4 4 0 0 0 4 4z"/><path d="M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V20H8.89a.89.89 0 0 0-.89.89v.22a.89.89 0 0 0 .89.89h6.22a.89.89 0 0 0 .89-.89v-.22a.89.89 0 0 0-.89-.89H13v-2.08A7 7 0 0 0 19 11z"/></g></g></svg>
                                                                    </div>
                                                                }
                                                                <button className={`${classes.send} ${!activeRecorder ? classes.active : ''}`} title="Send" onClick={() => sendVoiceNote()} disabled={activeRecorder || isSending}>
                                                                    {
                                                                        isSending ? <Loader /> : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M223.44434,114.03906,54.5293,19.44727A16.00042,16.00042,0,0,0,31.64355,38.78906L60.64746,120H136a8,8,0,0,1,0,16H60.64746L31.64355,217.21094a16.0398,16.0398,0,0,0,15.041,21.4082,16.039,16.039,0,0,0,7.8457-2.06641l168.91309-94.59179a16.00165,16.00165,0,0,0,.001-27.92188Z"/></svg>
                                                                    }
                                                                </button>
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>
                                                </>
                                            : <div className={classes.page_main}>
                                                <p className="text text-muted">Start a conversation by clicking 'Message' on that channel</p>
                                                <div className="btn">
                                                    <Link className="btn btn-primary" to='/channels'>Browse channels</Link>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/* <Footer /> */}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Messages;